<template>
  <v-card>
    <v-card-title>
      <v-layout>
        <v-flex>
          <span class="headline">{{ action + " " + title }}</span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex text-right v-if="action != 'Add'">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn class="mb-2" v-on="on" icon
                ><v-icon small @click="$emit('delete-item', $event)">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
            <span>{{ "Delete " + title }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-alert v-if="errorMessage != null" dense outlined type="error">
      {{ errorMessage }}
    </v-alert>
    <v-card-text v-if="loadingMessage != null">
      <v-layout mt-4>
        <v-flex>
          <h2 class="text-center grey--text text--lighten-1">
            {{ loadingMessage }}
          </h2>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-progress-linear
          :indeterminate="true"
          color="orange darken-4"
        ></v-progress-linear>
      </v-layout>
    </v-card-text>
    <v-card-text v-if="action == 'Delete' && loadingMessage == null">
      Are you sure you want to delete this item?
    </v-card-text>
    <v-card-text v-show="action != 'Delete'">
      <v-container>
        <ProjectForm
          v-if="title == 'Project'"
          :userid="userid"
          :data="data"
          :action="action"
          :savingForm="savingForm"
          @error="errorHandler"
          @success="successHandler"
          @valid-form="validForm = $event"
          @loading="loadingMessage = $event"
          @update-table="$emit('update-table', $event)"
        ></ProjectForm>
        <TaskForm
          v-if="title == 'Task'"
          :userid="userid"
          :data="data"
          :action="action"
          :savingForm="savingForm"
          @error="errorHandler"
          @success="successHandler"
          @valid-form="validForm = $event"
          @loading="loadingMessage = $event"
          @update-table="$emit('update-table', $event)"
        ></TaskForm>
        <ClientForm
          v-if="title == 'Client'"
          :userid="userid"
          :data="data"
          :action="action"
          :savingForm="savingForm"
          @error="errorHandler"
          @success="successHandler"
          @valid-form="validForm = $event"
          @loading="loadingMessage = $event"
          @update-table="$emit('update-table', $event)"
        ></ClientForm>
        <TeamMemberForm
          v-if="title == 'Team Member'"
          :userid="userid"
          :data="data"
          :action="action"
          :savingForm="savingForm"
          @error="errorHandler"
          @success="successHandler"
          @valid-form="validForm = $event"
          @loading="loadingMessage = $event"
          @update-table="$emit('update-table', $event)"
        ></TeamMemberForm>
        <ServiceTypeForm
          v-if="title == 'Service Type'"
          :data="data"
          :action="action"
          :savingForm="savingForm"
          @error="errorHandler"
          @success="successHandler"
          @valid-form="validForm = $event"
          @loading="loadingMessage = $event"
          @update-table="$emit('update-table', $event)"
        ></ServiceTypeForm>
        <SubmitTimeForm
          v-if="title == 'Time Submission'"
          :userid="userid"
          :data="data"
          :action="action"
          :savingForm="savingForm"
          @error="errorHandler"
          @success="successHandler"
          @valid-form="validForm = $event"
          @loading="loadingMessage = $event"
          @update-table="$emit('update-table', $event)"
        ></SubmitTimeForm>
        <SubmitExpenseForm
          v-if="title == 'Expense Submission'"
          :userid="userid"
          :data="data"
          :action="action"
          :savingForm="savingForm"
          @error="errorHandler"
          @success="successHandler"
          @valid-form="validForm = $event"
          @loading="loadingMessage = $event"
          @update-table="$emit('update-table', $event)"
        >
        </SubmitExpenseForm>
        <PaymentForm
          v-if="title == 'Payment'"
          :userid="userid"
          :data="data"
          :action="action"
          :savingForm="savingForm"
          @error="errorHandler"
          @success="successHandler"
          @valid-form="validForm = $event"
          @loading="loadingMessage = $event"
          @update-table="$emit('update-table', $event)"
        >
        </PaymentForm>
      </v-container>
    </v-card-text>

    <v-card-actions
      v-if="dialogSuccessMessage == null && dialogLoading == false"
    >
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="$emit('close')">Cancel </v-btn>
      <v-btn
        color="blue darken-1"
        text
        @click="saveForm()"
        :disabled="!readyToSave"
        >{{ this.action == "Delete" ? "Delete" : "Save" }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import TeamMemberForm from "@/components/DialogForm/TeamMemberForm.vue";
import SubmitTimeForm from "@/components/DialogForm/SubmitTimeForm.vue";
import ClientForm from "@/components/DialogForm/ClientForm.vue";
import ProjectForm from "@/components/DialogForm/ProjectForm.vue";
import SubmitExpenseForm from "@/components/DialogForm/SubmitExpenseForm.vue";
import ServiceTypeForm from "@/components/DialogForm/ServiceTypeForm.vue";
import TaskForm from "@/components/DialogForm/TaskForm.vue";
import PaymentForm from "@/components/DialogForm/PaymentForm.vue";

export default {
  name: "DialogForm",
  props: ["userid", "action", "title", "data", "lastsubmission"],
  components: {
    TeamMemberForm,
    SubmitTimeForm,
    ClientForm,
    ProjectForm,
    SubmitExpenseForm,
    ServiceTypeForm,
    TaskForm,
    PaymentForm
  },
  data: () => ({
    savingForm: false,
    loadingMessage: null,
    errorMessage: null,
    successMessage: null,

    showTeamMemberDialog: false,
    validForm: false,
    adminSwitch: false,
    loading: false,
    dialogLoadingMessage: null,
    deleteRow: false,
    search: null,
    formTitle: "",
    dialogLoading: false,
    dialogSuccessMessage: null,
    dialogErrorMessage: null,
    showUserDialog: false,
    userData: {},
    phoneMask: "###-###-####",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    headers: [
      {
        text: "Name",
        align: "left",
        value: "name",
        sortable: true
      },
      { text: "User Type", value: "type", sortable: true },
      { text: "Hours", value: "hours", sortable: false },
      { text: "Labor", value: "labor", sortable: false }
    ]
  }),
  computed: {
    readyToSave() {
      return this.action === "Delete" || this.validForm === true;
    }
  },
  watch: {
    showTeamMemberDialog(val) {
      val || this.close();
    }
  },

  methods: {
    errorHandler(errorMessage) {
      this.loadingMessage = null;
      this.savingForm = false;
      this.errorMessage = errorMessage;
    },
    successHandler(successMessage) {
      this.$emit("success", successMessage);
    },
    customSort: function(items, index, isDesc) {
      items.sort((a, b) => {
        if (index[0] == "id") {
          if (!isDesc[0]) {
            return parseInt(a[index].replace(/\D/g, "")) >
              parseInt(b[index].replace(/\D/g, ""))
              ? 1
              : -1;
          } else {
            return parseInt(b[index].replace(/\D/g, "")) >
              parseInt(a[index].replace(/\D/g, ""))
              ? 1
              : -1;
          }
        }
      });
      return items;
    },
    resetErrors() {
      this.errorMessage = null;
      this.successMessage = null;
      this.dialogSuccessMessage = null;
      this.dialogErrorMessage = null;
    },
    showTeamMemberForm(item) {
      this.resetErrors();
      if (item == null) {
        this.userData = {};
        this.formTitle = "Add New Team Member";
      } else {
        this.userData = JSON.parse(JSON.stringify(item));
        this.formTitle = "Edit Team Member: " + item.name;
      }
      this.showTeamMemberDialog = true;
    },
    saveForm() {
      this.resetErrors();
      this.savingForm = true;
    },
    deleteItem() {
      this.deleteRow = true;
      this.formTitle = "Delete Team Member: " + this.userData.name;
    },
    close() {
      this.showTeamMemberDialog = false;
      this.deleteRow = false;
    },
    downloadTable() {
      let headers = [];
      for (var header of this.headers) {
        if (header.value != "action") {
          headers.push(header.value);
        }
      }
      let csvContent = "data:text/csv;charset=utf-8," + headers.join(",");

      for (var user of this.users) {
        let userData = [];
        for (var head of headers) {
          userData.push(user[head]);
        }
        csvContent += "\n" + userData.join(",");
      }

      const data = encodeURI(csvContent.replace(/(^\[)|(\]$)/gm, ""));
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "Team.csv");
      link.click();
    }
  },
  mounted() {
    // this.refreshUsers();
  }
};
</script>
